import { hexColor, Show, Text, View } from "@lightningtv/solid";
import { isVpnMode } from "../../../state";
import { fontFamily, t } from "../../translations/configuration";
import { createSignal } from "solid-js";

export function PrivacyModeButton(props: any) {
    const [focused, setFocused] = createSignal(false);
    return (
        <View
            x={props.x} y={props.y}
            ref={props.onRef}
            width={250} height={85}
            borderRadius={36}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onEnter={props.onEnter}
            onUp={props.onUp}
        >
            <Show when={focused()}>
                <View
                    x={-2} y={-2}
                    width={304} height={76}
                    borderRadius={18}
                    color={hexColor("#2563eb")}
                    zIndex={-1}
                />
            </Show>
            <View
                x={0} y={0}
                width={300} height={72}
                borderRadius={18}
                color={hexColor("#26272c")}
            >
                <View
                    x={25} y={20}
                    src={isVpnMode() ? "https://i.ibb.co/Xfp2tGZS/diamond-Green.png" : "https://i.ibb.co/0p2DNKCg/diamond.png"}
                    width={30} height={30}
                />
                <Text x={75} y={25} style={{ fontSize: 26, color: hexColor("#f0f6fc"), fontFamily: fontFamily() }}>
                    {t("privacyMode")}
                </Text>
            </View>
        </View>
    );
}